import { apiFetch } from './client';
import { DEFAULT_PLAN_BILLING_CYCLE, type PlanBillingCycle } from '@/lib/plan-pricing';

export interface CheckoutSessionResponse {
  clientSecret: string;
  sessionId: string;
}

export const billingApi = {
  createCheckout: (planId: string, billingCycle: PlanBillingCycle = DEFAULT_PLAN_BILLING_CYCLE) =>
    apiFetch<CheckoutSessionResponse>('/billing/checkout', {
      method: 'POST',
      body: { planId, billingCycle },
    }),

  verifyCheckout: (sessionId: string) =>
    apiFetch<import('./profile').UserPlanResponse>(
      `/billing/checkout/verify?session_id=${encodeURIComponent(sessionId)}`
    ),
};
